
// トップページ

import Vue from 'vue';
import HomeVisualCompo from '../../../vue/home/home-visual.vue';

import check_ua from '../../caracol_es2015.1.0/util/check_user_agent';

import wordpress from '../../module/wordpress';
import set_transform from '../../caracol_es2015.1.0/effect/transform_css';



export default function () {

    if ($('#page-home').length >= 1) {
        page_home();
    }

    /**
     * トップページ用スクリプト
     */
    function page_home() {
        // WPのjsonを読み込んで表示
        wordpress();

        // ニュース部分のスクロール
        $('.js-news-scroll').perfectScrollbar();

        // フェードイン完了した
        $(window).on('fadein_complete', function () {
            // 動画窓
            // if (Cookies.get('yyy2_home_movie') !== 'true') {
            //     $('a.js-youtube-autoplay').trigger('click');
            //     Cookies.set('yyy2_home_movie', 'true', { expires: 1 });
            // }
        });

        // キービジュアル入れ替え用Vue インスタンス
        const vm = new Vue({
            el: check_ua.isMobile ? '#app-home-visual-sp' : '#app-home-visual-pc',
            components: {
                'home-visual': HomeVisualCompo
            }
        });

    }

}



// WEBPACK FOOTER //
// ./js/page/home/home.js